import { DashboardPage } from ".";
import { MenuNode, MenuRoute } from "../../components/menu";
import { LeafRole } from "../../utils/and-or-tree";
import { ShellRouteNames } from "../shell/route-names";

const name = `${ShellRouteNames.shell}.dashboard`;

const state: MenuRoute = {
  name: name,
  component: DashboardPage,
  url: "/",
  data: {
    title: "dashboard",
  },
};

const sidebar: MenuNode.MenuNode = {
  icon: "dashboard",
  route: state,
  roles: new LeafRole("ROLE_USER"),
};

export const DashboardRoutes = {
  name,
  state,
  sidebar,
};
